import { Component } from '@angular/core';
import { RevealDirective } from '../../../directives/reveal.directive';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-industry',
  standalone: true,
  imports: [RevealDirective, RouterModule],
  templateUrl: './industry.component.html',
})
export class IndustryComponent {}
